import React, {createRef, useState} from 'react';
import moment from "moment";
import __ from "lodash";
import {Button, FormGroup, Grid, Icon} from "@material-ui/core";

import {FormMemo, LabelledPaper, LightTooltip, RadioButtonGroup} from "../../../../controls";
import DateSelector from "../../../../controls/DatePicker";
import BookingSummaryDialog from "../../../../controls/FormDialog";
import PreBookingFormDialog from "../../../../controls/FormDialog";
import LoadingDecisionDialog from "../../../../controls/FormDialog";
import PreBookValidator from "../../validators/PreBookValidator";
import LoadableValidator from "../../validators/LoadableValidator";
import BookingSummaryGrid from "../BookingSummaryGrid";
import FlightOptions from "../FlightOptions";


const preBookButtons = {
  save:{icon: "check_circle", label: "Book", color: "primary", disabled: (status)=>{return status.error}},
  confirm:{icon: "confirmation_number", label: "Book and Confirm", color: "primary", disabled: (status)=>{return status.error}},
  cancel:{icon: "cancel", label: "Close", color: "primary"}
};

const bookingSummaryButtons = {
  cancel:{icon: "cancel", label: "Close", color: "primary"}
};

const LoadableButtons = {
  save:{icon: "check_circle", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
  cancel:{icon: "cancel", label: "Close", color: "primary"}
};

const decisionRadioButtons = [
  {label: "Loadable", value: "LOADABLE", disabled: false, size: "small"},
  {label: "Not Loadable", value: "NOT LOADABLE", disabled: false, size: "small"},
];


export default (SystemData, apiSitePrefix, extraKeys, handleReassignBooking, handleUpdateLoadable) => {
  const eventBus = SystemData.eventBus;

  const [editRow, setEditRow] = useState({});
  const [bookingsSummary, setBookingsSummary] = useState({tripNumber: "", destinations: [], totals: {}});
  const [dialogStates, setDialogStates] = useState({
    showPreBookingDialog: false,
    showBookingSummary: false,
    showSlrDecisionDialog: false,
  });

  // const minDate = moment.utc().add(1, 'day');
  // const minDeliveryDate = moment.utc(minDate).add(-3, 'day');
  const dateFormat = "DD/MM/YYYY";

  const preBooking = (rowData) => {
    setEditRow({...rowData});
    setDialogStates({...dialogStates, showPreBookingDialog:true});
  }

  const showBookingSummary = (bookingSummary, totals, tripNumber) => {
    if (bookingSummary)
      setBookingsSummary({tripNumber: tripNumber, destinations: bookingSummary, totals: totals});
    setDialogStates({...dialogStates, showBookingSummary:true});
  }

  const loadingDecision = (rowData) => {
    setEditRow({...rowData});
    setDialogStates({...dialogStates, showSlrDecisionDialog:true});
  }

  const dialogBoxes = (
    <>
      {dialogStates.showPreBookingDialog?
        <PreBookingFormDialog
          title={`Rebook ${editRow.awbNo} to a New Flight`}
          message=""
          open={dialogStates.showPreBookingDialog}
          record={editRow}
          buttons={preBookButtons}
          dialogOptions={{maxWidth: "sm", fullWidth: true}}
          validator={PreBookValidator}
          onChange={(state) => {
            //TODO: implement the SAVE option
            if (state.buttonPressed === "save" || state.buttonPressed === "confirm") {
              const record = state.record;
              const newStatus = state.buttonPressed === "save" ? "PRE-BOOKING" : "CONFIRMED";
              record.bookingStatus = newStatus;

              handleReassignBooking.mutate({
                extraKeys,
                record,
                postSuccess: () => {
                  setDialogStates({...dialogStates, showPreBookingDialog: false})
                },
                postError: (data) => {
                  if (data.errorMessage) {
                    SystemData.alert("Error", `${data.errorMessage}`);
                  } else {
                    SystemData.alert("Error", `An Unexpected Error rebooking the shipment.`);
                  }
                }
              });
            } else {
              setDialogStates({...dialogStates, showPreBookingDialog: false});
            }
          }}

        >
          <Grid container checkChildren={true} spacing={3}>
            <Grid item xs={6} checkChildren={true}>
              <DateSelector
                id="requestedDate"
                label="Current Flight Date"
                style={{width: "100%"}}
                readOnly
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
              />
            </Grid>
            <Grid item xs={6} checkChildren={true}>
              <DateSelector
                id="expectedAvailabilityAtOrigin"
                label="Current delivery at departure point"
                style={{width: "100%"}}
                readOnly
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
              />
            </Grid>
            <Grid item xs={6} checkChildren={true}>
              <DateSelector
                id="newFlightDate"
                label="New Flight Date"
                style={{width: "100%"}}
                // minDate={minDate}
                // defaultValue={minDate}
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
              />
            </Grid>
            <Grid item xs={6} checkChildren={true}>
              <DateSelector
                id="revisedExpectedAvailabilityAtOrigin"
                label="Expected delivery at departure point"
                style={{width: "100%"}}
                // minDate={minDeliveryDate}
                // emptyValue="00/00/0000"
                disableToolbar={true}
                autoOk={true}
                format={dateFormat}
              />
            </Grid>
            <Grid item xs={8} checkChildren={true} >
              {record=>(
                <LightTooltip title={record.departureFlight || ""} >
                  <div className={"MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"} readonly="" style={{textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden"}}>
                    <label className={"MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"} dataShrink={true}>New Departure Flight</label>
                    <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-fullWidth MuiInput-fullWidth MuiInputBase-formControl MuiInput-formControl readOnly" shrink="true">
                      <div style={{ marginTop: 8, marginBottom: 5, textOverflow: "ellipsis", whiteSpace:"nowrap", overflow: "hidden"}} >
                        {record.departureFlight || "Flight not selected yet"}
                      </div>
                    </div>
                  </div>
                </LightTooltip>
              )}
            </Grid>
            <Grid item xs={4} checkChildren={true}>
              {(record, changeRecord) => {console.log(record); return(
                <Button
                  id="search"
                  variant="text"
                  color="primary"
                  size="medium"
                  style={{marginLeft: 20, marginTop: 10}}
                  startIcon={<Icon>search_outlined</Icon>}
                  disabled={!record.origin || record.origin === "" || !record.destination || record.destination === "" || !record.newFlightDate}
                  onClick={()=>{
                    record["charterOrigin"] = record.origin;
                    record["flightDate"] = record.newFlightDate;
                    eventBus.trigger("GetBookingFlightOptions.open", record);
                  }}
                >
                  Search Flights
                </Button>)
              }}
            </Grid>
            {(record, changeRecord) =>
              {
                return (record.origin && record.origin !== "" && record.destination && record.destination !== ""
                    ?
                      <FlightOptions
                        close={(flightDate, departureFlight, trips, flights)=>{
                          const originDelivery = moment(flightDate ).add(-3, 'days').format("YYYY-MM-DD")
                          changeRecord({flightDate, originDelivery, departureFlight, viaRouting: {departureFlight, trips, flights} });
                        }}
                      />
                    :
                      <></>
                )
              }
            }
          </Grid>
        </PreBookingFormDialog>
        :<></>
      }

      {dialogStates.showBookingSummary
        ?
          <BookingSummaryDialog
            title={`Bookings Summary for Trip - ${bookingsSummary.tripNumber}`}
            open={dialogStates.showBookingSummary}
            record={editRow}
            buttons={bookingSummaryButtons}
            dialogOptions={{maxWidth: "md", fullWidth: true}}
            onChange={(state) => {
              if (state.buttonPressed === "cancel") {
                setDialogStates({...dialogStates, showBookingSummary: false});
              }
            }}
          >
            <BookingSummaryGrid
              destinations={bookingsSummary.destinations}
              totals={bookingsSummary.totals}
              height={90 * (bookingsSummary.destinations.length + 1)}
            />
          </BookingSummaryDialog>
        :
          <></>
      }

      {dialogStates.showSlrDecisionDialog?
        <LoadingDecisionDialog
          title={`Update ${editRow.spotReference} (${editRow.awbNo}) Loadable Status`}
          message="Update whether the Spot Request shipment is loadable prior to processing the Spot Rate Request"
          open={dialogStates.showSlrDecisionDialog}
          record={editRow}
          buttons={LoadableButtons}
          dialogOptions={{maxWidth: "sm", fullWidth: true}}
          validator={LoadableValidator}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const record = state.record;
              const result = record.loadable;
              handleUpdateLoadable(record, result, record.loadabilityNotes);
              setDialogStates({...dialogStates, showSlrDecisionDialog: false});
            } else {
              setDialogStates({...dialogStates, showSlrDecisionDialog: false});
            }
          }}
        >
          <Grid container checkChildren={true} spacing={3}>
            <Grid item xs={12} />
            <Grid item xs={12} checkChildren={true}>
              <LabelledPaper checkChildren={true} label="Loadable">
                <FormGroup checkChildren={true} key="FG-Loadable" style={{padding: "0px 8px 0px 8px"}}>
                  <RadioButtonGroup
                    id="loadable"
                    key="RBG-loadable"
                    buttons={decisionRadioButtons}
                  />
                </FormGroup>
              </LabelledPaper>
            </Grid>
            <Grid item xs={12} checkChildren={true} >
              <FormMemo
                id="loadabilityNotes"
                label="Loadable Decision Notes to Commercial Department"
                shrink={true}
              />
            </Grid>
          </Grid>
        </LoadingDecisionDialog>
        :<></>
      }

    </>
  )

  return {
    preBooking,
    showBookingSummary,
    loadingDecision,
    dialogBoxes
  }
}
